export default "__VITE_ASSET__C6ScWLR9__"